export default __webpack_public_path__ + "images/big-number-dummy-140.3d0ff10ccfc04180894569130f5b5a3d.svg";